(function () {
  const calculate = function (capacity, watts, humidifierWatts, tubeWatts, nightHours) {
    const totalWatts = watts + humidifierWatts + tubeWatts;
    if (![capacity, watts, humidifierWatts, tubeWatts, nightHours].every(Number.isFinite) || capacity <= 0 || watts < 1 || humidifierWatts < 0 || tubeWatts < 0 || nightHours < 1 || nightHours > 24) return null;
    const upperHours = capacity * 0.82 / totalWatts;
    const planningHours = Number((capacity * 0.82 * 0.85 / totalWatts).toPrecision(14));
    return { totalWatts: totalWatts, upperHours: upperHours, planningHours: planningHours, fullNights: Math.floor(planningHours / nightHours), covered: planningHours >= nightHours, coveragePercent: Math.min(100, planningHours / nightHours * 100) };
  };
  const initialize = function (section) {
    if (section.dataset.runtimeBound === 'true') return;
    section.dataset.runtimeBound = 'true';
    const get = function (selector) { return section.querySelector(selector); };
    const strings = JSON.parse(get('[data-runtime-strings]').textContent);
    const battery = get('[data-runtime-battery]');
    const batteryFacts = new Map();
    Array.from(battery.options).forEach(function (option) {
      try {
        const facts = JSON.parse(option.dataset.facts);
        if (!facts || facts.key !== option.value || !(facts.capacity > 0)) throw new Error('Missing model facts');
        batteryFacts.set(option.value, facts);
        option.dataset.capacity = String(facts.capacity);
        option.dataset.name = facts.label;
        option.dataset.url = window.Shopify.routes.root + 'products/' + facts.handle;
        option.textContent = facts.label + ' · ' + facts.capacity + 'Wh';
      } catch (error) { option.disabled = true; }
    });
    const watts = get('[data-runtime-watts-input]');
    const humidifier = get('[data-runtime-humidifier]');
    const tube = get('[data-runtime-heated-tube]');
    const night = get('[data-runtime-night-hours]');
    const status = get('[data-runtime-status]');
    const error = get('[data-runtime-error]');
    const fields = [watts, humidifier, tube, night];
    const format = function (value) { return (Math.floor(value * 10 + 1e-9) / 10).toFixed(1); };
    const template = function (text, values) { return Object.keys(values).reduce(function (out, key) { return out.split('__' + key + '__').join(String(values[key])); }, text); };
    const readPlan = function () { try { return window.ELPowerPlan?.read() || {}; } catch (error) { return {}; } };
    const saved = readPlan();
    const plan = window.ELPowerPlan;
    const machine = get('[data-runtime-machine]');
    (plan?.devices || []).forEach(function(device) {
      const option = new Option(device.model, device.model); option.dataset.brand=device.brand; machine.add(option);
    });
    machine.value = plan?.deviceFor(saved.machine)?.model || '';
    let powerSource = saved.powerSource || 'generic';
    const renderDevice = function () {
      const device = plan?.deviceFor(machine.value);
      get('[data-runtime-device]').hidden=!device;
      if (!device) return;
      get('[data-runtime-device-title]').textContent=device.model;
      get('[data-runtime-device-note]').textContent=device.note;
      get('[data-runtime-device-source]').href=device.source;
      plan.renderDeviceDetails(get('[data-runtime-device]'),device);
      get('[data-runtime-reference-note]').textContent=device.reference?.condition || 'No comparable overnight DC average has been verified for this model. The generic scenarios below are examples only; enter your measured average for a personal estimate.';
      get('[data-runtime-reference]').hidden=!device.reference;
      get('[data-runtime-reference]').textContent=device.reference ? 'Use this no-heat reference · '+device.reference.watts+'W' : '';
      get('[data-runtime-community]').hidden=!device.community;
      if(device.community){get('[data-runtime-community-note]').textContent=device.communityNote;get('[data-runtime-community-source]').href=device.community;}
    };
    renderDevice();
    let missingHeatLoads = false;
    if (saved.heat === 'on' || saved.heat === 'sometimes') {
      [[humidifier, 'humidifierWatts'], [tube, 'tubeWatts']].forEach(function (pair) {
        if (typeof saved[pair[1]] !== 'number' || !Number.isFinite(saved[pair[1]]) || saved[pair[1]] < 0 || saved[pair[1]] > 200) { pair[0].value = ''; missingHeatLoads = true; }
      });
    }
    let restoredInputs = ['watts','nightHours','humidifierWatts','tubeWatts'].some(function(key){return Number.isFinite(saved[key]);});
    const requestedBattery = new URLSearchParams(window.location.search).get('battery');
    const validBattery = function (key) { return Array.from(battery.options).some(function (option) { return !option.disabled && option.value === key; }); };
    if (validBattery(requestedBattery)) battery.value = requestedBattery;
    else if (validBattery(saved.batteryKey)) battery.value = saved.batteryKey;
    [[watts, 'watts'], [humidifier, 'humidifierWatts'], [tube, 'tubeWatts'], [night, 'nightHours']].forEach(function (pair) {
      const input = pair[0], value = saved[pair[1]];
      if (typeof value === 'number' && Number.isFinite(value) && value >= Number(input.min) && value <= Number(input.max)) input.value = String(value);
    });
    const proBox = get('[data-runtime-pro]');
    const proKeys = { es270: 'es720-pro', 'es400-air': 'es720-pro', es720: 'es720-pro', es960: 'es960-pro' };
    let alternativePro = null;
    const updateBatteryUrl = function () {
      try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('battery')) return;
        url.searchParams.set('battery', battery.value);
        window.history.replaceState(window.history.state, '', url.href);
      } catch (error) {}
    };
    const renderPro = function (selected, result) {
      alternativePro = null;
      if (!proBox) return;
      proBox.hidden = true;
      const state = readPlan();
      const device = plan?.deviceFor(machine.value);
      const targetKey = proKeys[selected?.value];
      const target = Array.from(battery.options).find(function (option) { return option.value === targetKey; });
      if (!result || !device || device.route !== 'dc' || state.situation === 'flight' || !target || target.disabled || target.dataset.available !== 'true') return;
      const adapter = Number(String(state.adapter || '').replace('v', ''));
      if (device.adapterVolts?.length && Number.isFinite(adapter) && adapter > 0 && !plan.adapterMatches(device.model, adapter)) return;
      const support = plan.supportFor(targetKey, device.model, device.brand);
      const targetFacts = batteryFacts.get(targetKey);
      const selectedFacts = batteryFacts.get(selected.value);
      if (!support || !targetFacts || !selectedFacts) return;
      const comparison = calculate(targetFacts.capacity, Number(watts.value), Number(humidifier.value), Number(tube.value), Number(night.value));
      if (!comparison) return;
      const included = plan.includedCableFor(targetKey, device.model, device.brand);
      const selectedIncluded = plan.includedCableFor(selected.value, device.model, device.brand);
      get('[data-runtime-pro-name]').textContent = targetFacts.label;
      get('[data-runtime-pro-price]').textContent = target.dataset.price || 'See current price';
      const proImage = get('[data-runtime-pro-image]');
      proImage.hidden = !target.dataset.image;
      if (target.dataset.image) proImage.src = target.dataset.image;
      proImage.alt = 'EASYLONGER ' + targetFacts.label + ' CPAP battery';
      const sameCapacity = targetFacts.capacity === selectedFacts.capacity;
      const capacityCopy = sameCapacity
        ? targetFacts.capacity + 'Wh, the same capacity and estimated runtime as ' + selectedFacts.label + '.'
        : targetFacts.capacity + 'Wh compared with ' + selectedFacts.capacity + 'Wh in ' + selectedFacts.label + '.';
      const chargingCopy = ' USB-C charging up to ' + targetFacts.usbCInputW + 'W' + (selectedFacts.usbCInputW ? ' versus ' + selectedFacts.usbCInputW + 'W' : '; ' + selectedFacts.label + ' charges through DC input') + '. A compatible charger and cable are required.';
      get('[data-runtime-pro-difference]').textContent = capacityCopy + chargingCopy;
      get('[data-runtime-pro-cable]').textContent = device.verifyRoute
        ? 'Confirm the original adapter and model-specific cable with support before choosing this PRO.'
        : included
          ? 'The ' + included.label + ' cable is included. Confirm the connector and output before use.'
          : (selectedIncluded ? 'The cable bundle changes: ' : '') + (support.label || 'Your model-specific cable') + ' is not included with this PRO. Confirm the separate cable before purchase.';
      get('[data-runtime-pro-runtime]').textContent = format(comparison.planningHours) + ' hours with your current inputs' + (comparison.covered ? '.' : ' — below your planned ' + night.value + '-hour night.');
      const proLink = get('[data-runtime-pro-link]');
      proLink.href = target.dataset.url;
      proLink.textContent = 'View ' + targetFacts.label;
      get('[data-runtime-pro-select]').textContent = 'Use ' + targetFacts.label;
      alternativePro = target;
      proBox.hidden = false;
    };
    const render = function (save) {
      const noHeat = humidifier.value === '0' && tube.value === '0';
      const isBaseline = Number(watts.value) === 12 && Number(night.value) === 8 && noHeat;
      get('[data-runtime-input-context]').textContent = powerSource === 'reference' ? 'Selected source case. Confirm that its conditions describe your setup; this is not a guaranteed runtime.' : restoredInputs ? strings.saved : isBaseline ? strings.baseline : strings.custom;
      section.querySelectorAll('[data-runtime-preset]').forEach(function(button){button.setAttribute('aria-pressed', String(noHeat && Number(watts.value)===Number(button.dataset.runtimePreset)));});
      const heatNote = get('[data-runtime-restored-heat]');
      heatNote.hidden = !missingHeatLoads && !(restoredInputs && (Number(humidifier.value) + Number(tube.value) > 0));
      heatNote.textContent = missingHeatLoads ? strings.heatMissing : strings.heatRestored;
      const selected = battery.selectedOptions[0];
      const requiresAC = plan?.deviceFor(machine.value)?.route === 'ac';
      let valid = Boolean(selected && Number(selected.dataset.capacity) > 0 && !requiresAC);
      fields.forEach(function (input) {
        const value = Number(input.value);
        const fieldValid = input.value.trim() !== '' && Number.isFinite(value) && value >= Number(input.min) && value <= Number(input.max);
        input.setAttribute('aria-invalid', fieldValid ? 'false' : 'true');
        if (!fieldValid) valid = false;
      });
      const result = valid ? calculate(Number(selected.dataset.capacity), Number(watts.value), Number(humidifier.value), Number(tube.value), Number(night.value)) : null;
      error.hidden = Boolean(result);
      error.textContent = requiresAC ? 'SleepStyle requires a separately verified AC/inverter setup. This DC calculator does not estimate that route. Contact support with your inverter and battery details.' : strings.invalid;
      get('[data-runtime-result]').hidden = !result;
      renderPro(selected, result);
      if (!result) { status.textContent = strings.invalid; return; }
      const name = selected.dataset.name || selected.textContent;
      get('[data-runtime-watts]').textContent = watts.value + 'W';
      get('[data-runtime-product-name]').textContent = name;
      get('[data-runtime-product-price]').textContent = selected.dataset.price || '';
      const image = get('[data-runtime-product-image]');
      if (selected.dataset.image) image.src = selected.dataset.image;
      image.alt = template(strings.imageAlt, { name: name });
      get('[data-runtime-product-use]').textContent = template(strings.capacity, { capacity: selected.dataset.capacity });
      get('[data-runtime-hours]').textContent = format(result.planningHours);
      get('[data-runtime-nights]').textContent = String(result.fullNights);
      get('[data-runtime-load]').textContent = format(result.totalWatts);
      get('[data-runtime-night-reference]').textContent = template(strings.nightReference, { hours: night.value });
      get('[data-runtime-coverage]').textContent = result.covered ? strings.covered : strings.short;
      get('[data-runtime-track]').style.width = result.coveragePercent + '%';
      get('[data-runtime-maximum]').textContent = template(strings.hours, { hours: format(result.upperHours) });
      get('[data-runtime-night-length]').textContent = template(strings.hours, { hours: night.value });
      const link = get('[data-runtime-product-link]');
      link.href = selected.dataset.url;
      link.textContent = template(strings.view, { name: name });
      status.textContent = template(strings.summary, { name: name, hours: format(result.planningHours), nights: result.fullNights, length: night.value, coverage: result.covered ? strings.covered : strings.short });
      let next = get('[data-runtime-next-step]');
      if (!next) { next=document.createElement('p'); next.dataset.runtimeNextStep=''; next.className='el-runtime-plan'; link.before(next); }
      const state = {...readPlan(), watts:Number(watts.value),humidifierWatts:Number(humidifier.value),tubeWatts:Number(tube.value),nightHours:Number(night.value)};
      next.textContent = format(result.totalWatts) + 'W total · ' + night.value + ' hours/night · 82% conversion efficiency · 15% reserve. Use a measured load and test your complete setup.' + (!result.covered ? ' ' + (state.situation === 'flight' ? plan?.journeyStrings.flightNext : plan?.journeyStrings.groundNext) : '');
      if (save) {
        try { window.ELPowerPlan?.write({ batteryKey: battery.value, powerSource, watts: Number(watts.value), humidifierWatts: Number(humidifier.value), tubeWatts: Number(tube.value), nightHours: Number(night.value), heat: Number(humidifier.value) + Number(tube.value) > 0 ? 'on' : 'off' }); } catch (error) {}
      }
    };
    machine.addEventListener('change',function(){
      const device=plan?.deviceFor(machine.value);
      if (powerSource === 'reference') {watts.value='12';humidifier.value='0';tube.value='0';powerSource='generic';restoredInputs=false;}
      if(device) plan.write({machine:device.model,brand:device.brand,powerSource});
      else plan?.write({machine:'Not listed / not sure',brand:'Other supported families',powerSource});
      renderDevice();render(true);
    });
    get('[data-runtime-reference]').addEventListener('click',function(){
      const reference=plan?.deviceFor(machine.value)?.reference;if(!reference)return;
      watts.value=String(reference.watts);humidifier.value='0';tube.value='0';powerSource='reference';restoredInputs=false;missingHeatLoads=false;render(true);
    });
    get('[data-runtime-pro-select]')?.addEventListener('click', function () {
      if (!alternativePro) return;
      battery.value = alternativePro.value;
      updateBatteryUrl();
      render(true);
      const selectedName = get('[data-runtime-result-heading]') || get('[data-runtime-product-name]');
      selectedName.setAttribute('tabindex', '-1');
      selectedName.focus({ preventScroll: true });
    });
    get('[data-runtime-jump-result]')?.addEventListener('click', function (event) {
      event.preventDefault();
      render(true);
      const result = get('[data-runtime-result]');
      const destination = result.hidden
        ? fields.find(function (input) { return input.getAttribute('aria-invalid') === 'true'; }) || error
        : get('[data-runtime-result-heading]') || get('[data-runtime-product-name]');
      if (!fields.includes(destination)) destination.setAttribute('tabindex', '-1');
      destination.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      destination.focus({ preventScroll: true });
    });
    get('[data-runtime-pro-link]')?.addEventListener('click', function () {
      if (alternativePro) plan.write({ batteryKey: alternativePro.value });
    });
    get('[data-runtime-pro-image]')?.addEventListener('error', function () { this.hidden = true; });
    [battery].concat(fields).forEach(function (input) { input.addEventListener('input', function () { if(input!==battery){restoredInputs=false;powerSource='measured';}else{updateBatteryUrl();}missingHeatLoads=humidifier.value.trim()===''||tube.value.trim()==='';render(true); }); });
    section.querySelectorAll('[data-runtime-preset]').forEach(function (button) { button.addEventListener('click', function () { watts.value = button.dataset.runtimePreset;humidifier.value='0';tube.value='0';if(button.dataset.runtimePreset==='12')night.value='8';powerSource='generic';restoredInputs=false;missingHeatLoads=false;render(true); }); });
    get('form').addEventListener('submit', function (event) { event.preventDefault(); render(true); });
    render(true);
  };
  const start = function () { document.querySelectorAll('[data-runtime-tool]').forEach(initialize); };
  if (document.readyState === 'complete') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
  document.addEventListener('shopify:section:load', function (event) { if (event.target.matches('[data-runtime-tool]')) initialize(event.target); else event.target.querySelectorAll('[data-runtime-tool]').forEach(initialize); });
})();
